import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { TRUE } from '../../utilities/constants';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { SignAndStampFile, SignAndStampFileCollection } from './queryBuilder';

const useSignAndStamp = (inspectionId: string, taskId: number) => {
  const getSignAndStampQuery = useCallback(
    (collection: SignAndStampFileCollection) =>
      collection?.find({ selector: { inspectionId, isDelete: { $ne: TRUE } } }),
    [inspectionId],
  );

  const { result } = useRxData<SignAndStampFile>(
    RxdbCollectionName.SIGN_AND_STAMP_FILE,
    getSignAndStampQuery,
  );

  const isFISignAvailable = !!result.find(e => e.fkAssetInspectionTask === taskId);
  const isLISignAvailable = !!result.find(e => !e.fkAssetInspectionTask);

  return { isFISignAvailable, isLISignAvailable };
};

export default useSignAndStamp;
